import { Card, Row, Col, Container, ListGroup,Button,Image,Badge } from "react-bootstrap";
import { faXmarkCircle, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NoiseVideo from '../../blocks/NoiseVideo';
import Person from "../../blocks/Person";
export default function DemoQuestionViwer(props){
    const question = props.question;   
    const answers = props.answers;    
    let rightAnswers = [];
    let falseAnswers = [];
    Array.prototype.map.call(answers, function(answer,index){
        if(answer.is_right)
        {
            rightAnswers.push(answer);
        }else{
            falseAnswers.push(answer);
        }
    });

    if(question){
        return(
            <Container>
                <Row>
                    <Col>
                        <Image className="w-100" src={question.file??courseImg} rounded />
                        <p style={{fontSize:"1.5em"}}>{question.text}</p>
                        {Array.prototype.map.call(rightAnswers, function(answer,index){
                            return <div key={index}>
                            <p title={props.t("Right answer")} style={{fontSize:"1.5em"}}><FontAwesomeIcon className={"text-success"} icon={faCircleCheck}/> <b>{answer.text??props.t("Answer has no text")}</b></p>
                        </div>
                        })}
                        <div>
                            <p style={{textTransform:"uppercase", fontSize:"1.7em"}}>{props.t("The striking factor")}:</p>
                            {
                                Array.prototype.map.call(falseAnswers, (answer,index)=>{
                                    return <Badge bg="danger" className="bg-danger text-white" style={{fontSize:"1.5em" ,whiteSpace: "pre-line"}}> 
                                 {Array.prototype.map.call(answer.factor_risk,(factor, index)=>{
                                                            return factor.title;
                                                        }).join(", ")}
                                                        </Badge> 
                                                    }
                                                    )[0]
                                }
                        </div>                                                
                    </Col>
                    <Col>
                        <div>
                            <p style={{textTransform:"uppercase", fontSize:"1.7em"}}>{props.t("The basis of the task")}</p>
                            <p>
                                {question.quote_from_document??props.t("The reason for the task is not specified")}
                            </p>
                        </div>
                        <div >
                            {Array.prototype.map.call(falseAnswers, function(answer,index){
                                return <div key={index}>
                                    <div style={{    display: "flex",
                                                    justifyContent: "flex-start",                                                    
                                                    
                                                    flexDirection: "row",
                                                    alignItems: "center"}}>
                                        <FontAwesomeIcon className={"text-danger mr-1"} style={{fontSize:"1.5em"}} icon={faXmarkCircle}/> 
                                        <Badge bg="danger" className="bg-danger text-white" style={{fontSize:"1.5em",     whiteSpace: "pre-line"}}> {answer.text}</Badge>                                   
                                    </div>
                                    <Row>
                                        <Col>
                                            <div className="">
                                                <h2 style={{fontSize:"1.2em"}}>{props.t('Development of a dangerous situation')}</h2>
                                                <p  style={{fontSize:"1em"}} className="text-info">
                                                    {answer.visualisation.factor_risk.length > 0
                                                        ? answer.visualisation.factor_risk.length > 1
                                                            ? answer.visualisation.factor_risk.map(el => `${el.title}, `)
                                                            : answer.visualisation.factor_risk.map(el => `${el.title}`)
                                                        : answer.visualisation.title}
                                                </p>
                                            </div>
                                            <NoiseVideo                                                
                                                id="video_visual"
                                                preload="auto"
                                                controls
                                                src={answer.visualisation.file}>
                                            </NoiseVideo>
                                        </Col>
                                        {!answer.injurie?
                                        <Col  className="mb-3">
                                            <h2 className={"mb-3"} style={{fontSize:"1.4em"}}>{props.t('Possible consequences')}</h2>
                                            <Row>
                                                <Col xs={"12"} sm={"8"}>
                                                    <p style={{fontSize:"1em"}} className="text-info">{props.t('Exposure to harmful and dangerous factors')}:</p>
                                                    <div className={"failVisual__dangerFactor mb-3"} style={{fontSize:"1em"}}>
                                                        {Array.prototype.map.call(answer.factor_risk,(factor, index)=>{
                                                            return factor.title;
                                                        }).join(", ")}
                                                    </div>
                                                    {answer.comment &&
                                                        <>
                                                            <h4 style={{fontSize:"1em"}}>{props.t('Harm to health')}:</h4>
                                                            <div className={"failVisual__comment mb-3"} style={{fontSize:"1em"}}>
                                                                {answer.comment}
                                                            </div>
                                                        </>}
                                                </Col>
                                                <Col xs={"12"} md={"4"} className="text-center">
                                                    <Person body_parts={answer.visualisation.body_part}/>
                                                </Col>
                                            </Row>                                       
                                        </Col>
                                        :
                                            <Col className="mb-3">
                                               <h2  style={{fontSize:"1.2em"}}>{props.t('Possible consequences')}</h2>
                                                <p style={{fontSize:"1em"}} className="text-info">
                                                    {answer.injurie.title}
                                                </p>
                                                <NoiseVideo
                                                    id="video_injurie"
                                                    preload="auto"           
                                                    controls                                                                                                                                                 
                                                    src={answer.injurie.file}                                            
                                                    >                                                
                                                </NoiseVideo>
                                            </Col>
                                        }
                                        
                                        
                                    </Row>
                                </div>
                            })}
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }else{
        return <></>
    }
}